export const GET_REGIONS = 'covid_data/countries/GET_REGIONS';

const getRegionsAction = (payload) => ({ type: GET_REGIONS, payload });

export default getRegionsAction;
